'use strict';

var taskTypeEntryFactory = require('./implementation/TaskType'),
    is = require('bpmn-js/lib/util/ModelUtil').is;

module.exports = function(group, element, translate) {

  if (!is(element, 'bpmn:Collaboration')) {

    var options;

    // name
    group.entries = group.entries.concat(taskTypeEntryFactory(element, options, translate));

  }

};
